module.exports = __webpack_public_path__ + "img/xsxx_icon.205741db.png";